module.exports = __webpack_public_path__ + "img/defeb18.jpg";